import React, { useState } from 'react';

const CompressionOptions = ({ onCompressionSubmit, compressedImage, uploadedImage, isCompressionInProgress, isCompressionComplete }) => {
    const [desiredSize, setDesiredSize] = useState('');
    const [hasSizeChanged, setHasSizeChanged] = useState(false); // Track if desired size has changed

    const handleSizeChange = (e) => {
        setDesiredSize(e.target.value);
        setHasSizeChanged(true); // Mark size as changed
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (desiredSize) {
            onCompressionSubmit(parseFloat(desiredSize));
            setHasSizeChanged(false); // Reset size change state
        }
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = compressedImage;

        const originalFileName = uploadedImage.name.split('.').slice(0, -1).join('.');
        const fileExtension = uploadedImage.name.split('.').pop();
        link.download = `${originalFileName}-compressed.${fileExtension}`;

        link.click();
    };

    return (
        <section className="compression-options">
            <div className="input-group">
                <fieldset className={`input-fieldset ${desiredSize ? 'has-value' : ''}`}>
                    {desiredSize && <legend>Enter desired size in KB</legend>}
                    <input
                        type="number"
                        id="desired-size"
                        value={desiredSize}
                        onChange={handleSizeChange}
                        placeholder="Enter desired size in KB"
                        min="1"
                        required
                    />
                </fieldset>
                {!isCompressionComplete || hasSizeChanged ? (
                    <button
                        onClick={handleSubmit}
                        className="compress-button"
                        disabled={isCompressionInProgress || !desiredSize}
                    >
                        {isCompressionInProgress ? 'Compressing...' : 'Compress'}
                    </button>
                ) : (
                    compressedImage && (
                        <button
                            onClick={handleDownload}
                            className="download-button"
                        >
                            Download
                        </button>
                    )
                )}
            </div>
        </section>
    );
};

export default CompressionOptions;